export const tr = {
    delete: 'Sil'
};
